module.exports = __webpack_public_path__ + "img/sert-mob.c5feb0db.svg";